// extracted by mini-css-extract-plugin
export var banner = "_q9-0";
export var settingRow = "_q9-2";
export var titleIcon = "_q9-1";